import { create } from "zustand"

type DeleteProjectDialogState = {
  isOpen: boolean
}

type DeleteProjectDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useDeleteProjectDialogV1 = create<
  DeleteProjectDialogState & DeleteProjectDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useDeleteProjectDialogV1
